var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPackedLiquid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 30,
    viewBox: "0 0 31 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M15.776 39.16a.452.452 0 0 1-.183 0L1.106 32.49a.426.426 0 0 1-.252-.391V2.969c0-.16.086-.307.226-.384a.409.409 0 0 1 .435 0l14.487 9.035a.426.426 0 0 1 .208.365v26.757a.435.435 0 0 1-.2.365.46.46 0 0 1-.234.052zM1.724 31.784l13.617 6.261V12.23L1.724 3.75v28.034z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M15.776 39.16a.442.442 0 1 1-.157-.87l14.27-5.444V7.255l-13.965 5.14-9.07 4.93a.443.443 0 0 1-.617-.226L.854 3.089a.435.435 0 0 1 0-.373.452.452 0 0 1 .322-.209l16.2-2.026a.496.496 0 0 1 .226 0L30.497 6.23c.098.041.176.12.218.217.009.046.009.094 0 .14v26.59a.435.435 0 0 1-.278.4l-14.505 5.557-.156.026zM1.897 3.324l4.974 13.043 8.696-4.722 13.6-5.078-11.791-5.217L1.897 3.325z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.645 34.481a.435.435 0 0 1-.435-.435V16.942a.435.435 0 0 1 .87 0v17.104c0 .24-.195.435-.435.435z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M23.384 28.69a4.296 4.296 0 0 1-3.99-2.722 4.557 4.557 0 0 1 0-3.14c.4-1.26.961-2.464 1.669-3.582.59-.97 1.232-1.907 1.921-2.808a.452.452 0 0 0 .087-.096.496.496 0 0 1 .366-.148c.13.001.253.058.339.157l.243.321.487.661a24.009 24.009 0 0 1 2.435 4.235 8.13 8.13 0 0 1 .687 2.33 4.157 4.157 0 0 1-1.13 3.479 4.287 4.287 0 0 1-3.114 1.313zm0-11.365a27.409 27.409 0 0 0-1.608 2.374 14.957 14.957 0 0 0-1.592 3.39 3.8 3.8 0 0 0 0 2.61 3.409 3.409 0 0 0 5.661 1.095 3.296 3.296 0 0 0 .87-2.748 7.591 7.591 0 0 0-.609-2.087 23.73 23.73 0 0 0-2.348-4.087l-.374-.547z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackedLiquid);
export default __webpack_public_path__ + "static/media/packed-liquid.bfd599486328c32b7b2a64fe575b8d49.svg";
export { ForwardRef as ReactComponent };